import {
  MenuItem,
  NativeSelect,
  Select,
  styled,
  Typography
} from "@material-ui/core";

export const MainTypography = styled(Typography)(({ theme }) => ({
  fontSize: "5rem",
  lineHeight: "7rem",
  letterSpacing: "-1px",
  fontFamily: "Reckless",
  textAlign: "center",
  whiteSpace: "nowrap",
  [theme.breakpoints.down("xs")]: {
    fontSize: "2.4rem",
    lineHeight: "4rem"
  }
}));

export const PriceTypography = styled(Typography)(({ theme }) => ({
  fontSize: "5.6rem",
  lineHeight: "6rem",
  letterSpacing: "-2px",
  fontFamily: "Reckless",
  [theme.breakpoints.down("xs")]: {
    fontSize: "4rem",
    lineHeight: "4.4rem",
    letterSpacing: "-1px"
  }
}));

export const LargePriceTypography = styled(Typography)(({ theme }) => ({
  fontSize: "7rem",
  lineHeight: "7rem",
  letterSpacing: "-2px",
  fontFamily: "Reckless",
  color: theme.palette.grey[100],
  [theme.breakpoints.down("xs")]: {
    fontSize: "6rem",
    lineHeight: "6rem",
    letterSpacing: "-1px"
  }
}));

export const DesktopCustomSelect = styled(Select)(({ theme }) => ({
  [theme.breakpoints.down("xs")]: {
    display: "none"
  },
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  fontSize: "5rem",
  lineHeight: "7rem",
  letterSpacing: "-1px",
  fontFamily: "Reckless",
  fontWeight: 600,
  zIndex: 1,
  paddingTop: 0,
  paddingBottom: 0,
  "& .MuiSelect-root.MuiSelect-select": {
    paddingRight: "28px",
    backgroundColor: "transparent"
  },
  "& svg": {
    userSelect: "none",
    marginLeft: "-24px"
  },
  "&:after": {
    display: "none"
  },
  "&:before": {
    position: "absolute",
    borderBottom: `6px solid ${theme.palette.primary.main}`,
    bottom: "22px",
    left: "-12px",
    zIndex: -1,
    width: "calc(100% + 12px)"
  },
  "&:hover:not(.Mui-disabled):before": {
    borderBottom: `6px solid #EFAA03`
  },
  "&:not(.Mui-disabled) svg path": {
    transition: "stroke 100ms"
  },
  "&:hover:not(.Mui-disabled) svg path": {
    stroke: theme.palette.common.black
  }
}));

export const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "2.6rem",
  lineHeight: 1.2,
  letterSpacing: "-1px",
  fontFamily: "Reckless",
  fontWeight: 500
}));

export const CustomMobileSelect = styled(NativeSelect)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    display: "none"
  },
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  fontSize: "2.4rem",
  letterSpacing: "-1px",
  fontFamily: "Reckless",
  fontWeight: 600,
  zIndex: 1,
  "& .MuiNativeSelect-root": {
    padding: "0 30px 0 0",
    background: "transparent"
  },
  "&:before": {
    position: "absolute",
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    bottom: "10px",
    left: "-8px",
    zIndex: -1,
    width: "calc(100% + 8px)",
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  "&:hover:not(.Mui-disabled):before": {
    borderBottom: `3px solid ${theme.palette.primary.main}`
  },
  "&:after": {
    display: "none"
  },
  "& svg": {
    marginLeft: "-36px",
    transform: "scale(0.6) translateY(-2px)"
  }
}));
